import css from 'styled-jsx/css';

export default css`h2 {
  font-size: 24px;
  font-weight: 500;
  line-height: 1.42;
  letter-spacing: 0.4px;
  text-align: center;
  color: #414141;
  margin-bottom: 64px;
  position: relative;
  margin-top: 160px; }

h2:after {
  content: '';
  display: block;
  width: 48px;
  height: 8px;
  background-color: #414141;
  border-radius: 4px;
  position: absolute;
  left: 50%;
  top: 50px;
  transform: translateX(-50%); }

.exposureResource {
  position: relative;
  transition: 2s; }
  .exposureResource h2 {
    text-align: center; }
  .exposureResource .flex-wrap {
    display: flex;
    align-items: center;
    width: 650px;
    margin: auto;
    justify-content: space-between; }
    @media only screen and (max-width: 500px) {
      .exposureResource .flex-wrap {
        display: block;
        width: auto; } }
    .exposureResource .flex-wrap .box {
      margin-bottom: 64px; }
      .exposureResource .flex-wrap .box .img {
        width: 250px; }
        @media only screen and (max-width: 500px) {
          .exposureResource .flex-wrap .box .img {
            margin: auto; } }
        .exposureResource .flex-wrap .box .img img {
          width: 100%; }
      .exposureResource .flex-wrap .box p {
        margin-top: 16px;
        color: black;
        text-align: center; }
    .exposureResource .flex-wrap .translate {
      margin-top: 100px; }
`